matchesStrictComparable